import base from "./base/index"; // 接口域名列表
import axios from "../utils/http"; // 导入http中创建的axios实例
import utils from "../utils";
/**
 * 采集原始数据
 */
const measuringRaw = {

  /**
   * 原始值查询
   */
  getMeasuringRawValue (measureId, startTime, endTime, pointCode, pointNumber, sort, limit) {
    return axios.post(base.measuringRaw.getMeasuringRawValue, utils.postParamsArrayToJsonString({ measureId, startTime, endTime, pointCode, pointNumber, sort, limit }))
  },
  /**
   * 查询所有瞬时数据
   */
  getMeasuringRawValue2 (measures, startTime, endTime, sort, limit) {
    return axios.post(base.measuringRaw.getMeasuringRawValue2, utils.postParamsArrayToJsonString({ measures, startTime, endTime, sort, limit }))
  },
  /**
   * 最新原始值查询
   */
  getLatestMeasuringRawValue (measureId, pointCode, pointNumber) {
    return axios.post(base.measuringRaw.getLatestMeasuringRawValue, utils.postParamsArrayToJsonString({ measureId, pointCode, pointNumber }))
  },
  /**
   * 原始值查询
   */
  getMeasuringRawValueHour (measureId, startTime, endTime, pointCode, pointNumber) {
    return axios.post(base.measuringRaw.getMeasuringRawValueHour, utils.postParamsArrayToJsonString({ measureId, startTime, endTime, pointCode, pointNumber }))
  },
  /**
   * 原始值查询
   */
  getMeasuringRawValueDay (measureId, startTime, endTime, pointCode, pointNumber) {
    return axios.post(base.measuringRaw.getMeasuringRawValueDay, utils.postParamsArrayToJsonString({ measureId, startTime, endTime, pointCode, pointNumber }))
  },
  /**
   * 原始值查询
   */
  getMeasuringRawValueMonth (measureId, startTime, endTime, pointCode, pointNumber) {
    return axios.post(base.measuringRaw.getMeasuringRawValueMonth, utils.postParamsArrayToJsonString({ measureId, startTime, endTime, pointCode, pointNumber }))
  },
  /**
   * 原始值查询
   */
  getMeasuringRawValueYear (measureId, startTime, endTime, pointCode, pointNumber) {
    return axios.post(base.measuringRaw.getMeasuringRawValueYear, utils.postParamsArrayToJsonString({ measureId, startTime, endTime, pointCode, pointNumber }))
  },
  /**
   * 原始值查询
   */
  getMeasuringRawValueHour2 (measures, startTime, endTime) {
    return axios.post(base.measuringRaw.getMeasuringRawValueHour2, utils.postParamsArrayToJsonString({ measures, startTime, endTime }))
  },
  /**
   * 原始值查询
   */
  getMeasuringRawValueDay2 (measures, startTime, endTime) {
    return axios.post(base.measuringRaw.getMeasuringRawValueDay2, utils.postParamsArrayToJsonString({ measures, startTime, endTime }))
  },
  /**
   * 原始值查询
   */
  getMeasuringRawValueMonth2 (measures, startTime, endTime) {
    return axios.post(base.measuringRaw.getMeasuringRawValueMonth2, utils.postParamsArrayToJsonString({ measures, startTime, endTime }))
  },
  /**
   * 原始值查询
   */
  getMeasuringRawValueYear2 (measures, startTime, endTime) {
    return axios.post(base.measuringRaw.getMeasuringRawValueYear2, utils.postParamsArrayToJsonString({ measures, startTime, endTime }))
  },
}

export default measuringRaw